import React = require('react');

export interface ISelectProps {
	items           : Array<ISelectItem>;
	itemChangeHandler: Function;
	key             : string
	submit_url?     : string
	new_title?      : string
	box_class?      : string
	input_text?     : string
	save_data?      : any
	enableNewItem   : boolean
	multifield_mode?: boolean
	viewMode?: boolean
}

export interface ISelectItem{
	name: string,
	id: number,
	selected: boolean
}

export interface ISelectState {
	name : string
	errors : Array<string>
    viewMode: boolean
}

export class Select extends React.Component<ISelectProps, ISelectState>{

  	constructor(props:ISelectProps){
  		super(props);
  		this.state = this.getInitState();
    }

	// componentDidMount() {
	// 	this.setState(this.getInitState());
	// }

	protected getInitState():any{
        var viewMode:boolean = false;
        if ( this.props.viewMode !== undefined ) {
            viewMode = this.props.viewMode;
        }
		return {
			name: '',
			items : [],
			errors : [],
            viewMode: viewMode
        };
	}

	nameChangeHandler(event) {
		this.setState({
			name: event.target.value.toString()
		} as ISelectState);
	}

  	submitHandler(e):void {
  		e.preventDefault();
  // 		if ( this.checkValid() ) {
		// 	// showLoader();
		// 	var submit_url:string = '/xhr/meta/newSelect';
		// 	if ( this.props.submit_url !== undefined ) {
		// 	    submit_url = this.props.submit_url;
		// 	}
		// 	var s_data:any = {
		// 		name: 		this.state.name
		// 	};
		// 	if ( this.props.save_data !== undefined ) {
		// 	    s_data = this.props.save_data;
		// 		s_data.filter = this.state.name;
		// 	}
  // 			$.ajax({
  // 				data:               s_data,
  // 				type:               "POST",
  // 				url:  				submit_url,
  // 				contentType:        "application/x-www-form-urlencoded;charset=UTF-8",
  // 				success: (data) => {
		// 			// hideLoader();
  // 					if ( data.success !== undefined
		// 			 	&& data.success === true ) {
		// 					var items = this.props.items;
		// 					var name = this.state.name;
		// 					if ( data.name !== undefined ) {
		// 					    name = data.name;
		// 					}
		// 					items.push({
		// 						id: data.id,
		// 						name: name,
		// 						selected: false
		// 					});
        //                     this.props.items = items;
		// 					this.setState({
		// 			  			errors : []
		// 			  		} as ISelectState);
  // 					}else if( data.error !== undefined ){
  // 						this.setState({
  // 							errors : [ data.error ]
  // 						} as ISelectState);
  // 					}
  // 				}
  // 			});
  // 		}
  	}

	private itemChangeHandler(e): void {
		e.preventDefault();
		var items_length:number = this.props.items.length;
		var current_items 		= this.props.items;

        var item      :ISelectItem = null;
        var item_index:number = -1;
        for (var key in current_items) {
            var t_item:ISelectItem = current_items[key];
            if ( t_item.id.toString() === e.target.value.toString() ) {
                item       = t_item;
                item_index = parseInt(key);
            }
        }

		if ( item_index > -1 ) {
			if ( this.props.multifield_mode !== undefined && this.props.multifield_mode === false ) {
                //not multiselect mode
                for ( key in current_items) {
                    if ( parseInt(key) !== item_index ) {
                        current_items[key].selected = false;
                    }
                }
                current_items[item_index].selected = !current_items[item_index].selected;
                if( current_items[item_index].selected === false){
                    this.props.itemChangeHandler(0);
                }else{
                    this.props.itemChangeHandler(item.id);
                }
			}else{
				current_items[item_index].selected = !current_items[item_index].selected;
				this.props.itemChangeHandler(current_items);
			}
			this.setState({
				errors : []
			} as ISelectState);
		}
	}



  	checkValid():boolean{
  		var err:Array<string> = [];

  		if ( this.state.name === '' ) {
  			err.push('Kérem, töltse ki a mezőt!');
  		}

  		this.setState({
  			errors : err
  		} as ISelectState);
  		return err.length === 0;
  	}

    render() {
        var errors = this.state.errors;
        var items = this.props.items;
		var new_item_form:any = {};
		if ( this.props.enableNewItem === false ) {
			new_item_form = {
				display: 'none'
			}
		}
		var new_title:string = 'Új mező hozzáadása:';
		if ( this.props.new_title !== undefined ) {
		    new_title = this.props.new_title;
		}
		var box_class:string = '';
		if ( this.props.box_class !== undefined ) {
		    box_class = this.props.box_class;
		}
		var input_text:string = 'Neve';
		if ( this.props.input_text !== undefined ) {
		    input_text = this.props.input_text;
		}
        var select_value:any = '';
        var selectedLabel:string = '';
        items.map((item:any) => {
            if ( item.selected === true ) {
                select_value = item.id;
                selectedLabel = item.name;
            }
        });
        if ( this.props.viewMode === true ) {
            return (<div>
                {selectedLabel}
            </div>
            );
        }
        return (
  			<div className={ box_class } style={ {display: 'block'} }>
                <label className="select_style">
    				<select className="select_component" value={select_value} onChange={ e => this.itemChangeHandler(e) }>
    					{items.map((item:any) => {
    						return <option key={item.id} value={item.id}>
                                {item.name}
    						</option>;
    					})}
    				</select>
                </label>
				<div style={ new_item_form } className="form form-horizontal" role="form">
					<div className="alert alert-danger">
						{errors.map((item:any) => {
							return <div>{item}</div>;
						})}
					</div>

	                <div className="col1">
	                	<strong>{ new_title }</strong>
						<input type="text" onChange={ e => this.nameChangeHandler(e) }  className="form-control" name="name" placeholder={ input_text } value={this.state.name} autoComplete="off" />
	                    <a href="javascript:void(0);" onClick={ e => this.submitHandler(e) } className="btn">
							<i className="ion-plus-circled"></i>
						</a>
	                </div>
	            </div>
  			</div>
        );
    }
}



// WEBPACK FOOTER //
// ./lib/components/Select.tsx